import { render, staticRenderFns } from "./CategoryUpsertModal.vue?vue&type=template&id=159ad65c"
import script from "./CategoryUpsertModal.vue?vue&type=script&lang=ts"
export * from "./CategoryUpsertModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports